import { Reducer } from "redux";
import {
    SET_CB_BRANCHES,
    SET_CB_COUNTRY,
    SET_CB_DIRECTION,
    TOGGLE_CB_BRANCHES,
} from "../actions/cbBranchesActions";

export interface ICBBranch {
    id: string;
    text: string;
}

export interface CBBranchesState {
    cbBranches: ICBBranch[];
    country: string;
    direction: string;
}

const initialState: CBBranchesState = {
    cbBranches: [],
    country: "",
    direction: "",
};

export const cbBranchesReducer: Reducer<CBBranchesState> = (
    state: CBBranchesState = initialState,
    action: any
): CBBranchesState => {
    switch (action.type) {
        case SET_CB_BRANCHES:
            return { ...state, cbBranches: action.branches };
        case SET_CB_COUNTRY:
            return { ...state, country: action.country };
        case SET_CB_DIRECTION:
            return { ...state, direction: action.direction };
        case TOGGLE_CB_BRANCHES:
            if (state.cbBranches.some(x => x.id === action.branch.id))
                return {
                    ...state,
                    cbBranches: state.cbBranches.filter(x => x.id !== action.branch.id),
                };
            else
                return {
                    ...state,
                    cbBranches: state.cbBranches.concat(action.branch),
                };
        default:
            return state;
    }
};
